import {useTranslation} from 'react-i18next'
import DatePickerV2 from '../../../components/DatePickerV2/DatePickerV2'
import {Selection} from '../../../components/Selection'
import {TextInputV2} from '../../../components/TextInputV2'
import {INVOICE_STATUS} from '../../../constants'
import {useSalesOrganization} from '../../../hooks/useSalesOrganization'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {invoiceSelector, setFilter} from '../../../redux/slices/invoiceSlices'
import {TRowFilter} from '../../../components/Table/Table'

export const RowFilter = () => {
  const {t} = useTranslation()
  const {salesOrgOptions} = useSalesOrganization()
  const {filter} = useAppSelector(invoiceSelector)
  const dispatch = useAppDispatch()

  return (
    <TRowFilter>
      <td>
        <TextInputV2
          placeholder={t('Invoice Number')}
          value={filter?.invoice_number ?? ''}
          onChange={({target}) => dispatch(setFilter({...filter, invoice_number: target.value}))}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Invoice Number SAP')}
          value={filter?.invoice_number_sap ?? ''}
          onChange={({target}) =>
            dispatch(setFilter({...filter, invoice_number_sap: target.value}))
          }
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('kontrak-soNomor')}
          value={filter?.so_number ?? ''}
          onChange={({target}) => dispatch(setFilter({...filter, so_number: target.value}))}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('So Number SAP')}
          value={filter?.so_number_sap ?? ''}
          onChange={({target}) => dispatch(setFilter({...filter, so_number_sap: target.value}))}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Customer Code')}
          value={filter?.customer_code ?? ''}
          onChange={({target}) => dispatch(setFilter({...filter, customer_code: target.value}))}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Customer Name')}
          value={filter?.customer_name ?? ''}
          onChange={({target}) => dispatch(setFilter({...filter, customer_name: target.value}))}
        />
      </td>
      <td>
        {/* FIXME: Unexpected result dari (BE) ketika memilih sales org */}
        <Selection
          placeholder={t('sub-order-produsen')}
          data={salesOrgOptions}
          value={filter?.sales_org_code ?? ''}
          onChange={(sales_org_code) => dispatch(setFilter({...filter, sales_org_code}))}
        />
      </td>
      <td>
        <DatePickerV2
          isSelectsRange={false}
          placeholder={t('tanggalInvoice')}
          startDate={filter?.invoice_date ?? ''}
          onChange={({startDate}) => dispatch(setFilter({...filter, invoice_date: startDate}))}
        />
      </td>
      <td>
        <DatePickerV2
          isSelectsRange={false}
          placeholder={t('Jatuh Tempo')}
          startDate={filter?.due_date ?? ''}
          onChange={({startDate}) => dispatch(setFilter({...filter, due_date: startDate}))}
        />
      </td>
      <td>
        <TextInputV2
          placeholder='Incoterm'
          value={filter?.incoterm ?? ''}
          onChange={({target}) => dispatch(setFilter({...filter, incoterm: target.value}))}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('mataUang')}
          value={filter?.currency ?? ''}
          onChange={({target}) => dispatch(setFilter({...filter, currency: target.value}))}
        />
      </td>
      <td>
        {/* FIXME: Ubah dangan Selection dengan options = kode term of payment (TOP) */}
        <TextInputV2
          placeholder={'TOP'}
          value={filter?.top ?? ''}
          onChange={({target}) => dispatch(setFilter({...filter, top: target.value}))}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Total Kuantum')}
          value={filter?.total_quantum ?? ''}
          onChange={({target}) => dispatch(setFilter({...filter, total_quantum: target.value}))}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Total Price')}
          value={filter?.total_price ?? ''}
          onChange={({target}) => dispatch(setFilter({...filter, total_price: target.value}))}
        />
      </td>
      <td>
        <Selection
          placeholder={t('Status')}
          data={INVOICE_STATUS}
          value={filter?.status ?? ''}
          onChange={(value: any) => dispatch(setFilter({...filter, status: value}))}
        />
      </td>
      <td className='td-order-6 text-center td-freeze pm-0'>
        <div style={{padding: '.9rem'}}>&nbsp;</div>
      </td>
    </TRowFilter>
  )
}
